import { Services } from '@sigma-frontend-libs/commons'
import { SendingStatus } from '@sigmasms/shared-types'

import { labelModes, proxy } from '@/utils'

import { sendingsStatuses } from '@/components/services/sendings/utils'

import render from './render'

export default {
  name: 'SendingStatus',

  mixins: [ proxy() ],

  props: {
    label: {
      type: String,
      default: ''
    },

    dense: {
      type: Boolean,
      default: true
    },
    rounded: {
      type: Boolean,
      default: true
    },
    clearable: {
      type: Boolean,
      default: true
    },
    details: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },

    labelMode: {
      type: String,
      default: labelModes.hidden,
      validator: value => {
        return Object.values(labelModes).includes(value)
      }
    }
  },

  computed: {
    items() {
      return Object.values(SendingStatus).map(value => {
        return {
          title: this.getTranslate(`${Services.sendings}.statuses.${value}`),
          icon: sendingsStatuses[value].icon,
          color: sendingsStatuses[value].color,
          value
        }
      })
    }
  },

  render
}

